import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {from, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {CommonRzmService} from './common-rzm.service';
import {RestEndPoints} from '../model/RestEndPoints';
import {AuthService} from './auth.service';
import { ChangeRequests, User, UserComment } from '@iana-rzms/bff-sdk';
import {BffClientService} from './bff-client.service';

@Injectable({
  providedIn: 'root'
})
export class ChangeRequestService extends CommonRzmService {

  constructor(
    @Inject(HttpClient) http,
    @Inject('env') environment,
    @Inject(AuthService) auth,
    bffClient: BffClientService
  ) {
    super(http, environment, auth, bffClient);
  }


  getListOfChangeRequests(page: number, size: number, type: string, searchText: string, descendingSort?: boolean): Observable<any> {
    const url = this.getRestEndPoint() + RestEndPoints.GET_CHANGE_REQUESTS + '?page=' + page + '&size=' + size + '&type=' + type + '&search=' + searchText + '&descendingSort=' + descendingSort;
    return this.getResponse<any>(url);
  }

  getChangeRequestDetails(changeRequestID: string): Observable<any> {
    const url = this.getRestEndPoint() + RestEndPoints.GET_CHANGE_REQUEST_DETAILS + changeRequestID;
    return this.getResponse(url);
  }

  getTechnicalCheckResponse(changeRequestID: string, techCheckID: string): Observable<any> {
    return from(ChangeRequests.getTechCheckResultById(this.sdkOptions({
      responseStyle: 'data',
      path: {
        changeRequestId: changeRequestID,
        techCheckId: techCheckID
      }
    }))).pipe(map(res => (res as any)?.data ?? res));
  }

  resendUserInvitation(userId: string, userEmail: string): Observable<any> {
    return from(User.sendInvitation(this.sdkOptions({
      responseStyle: 'data',
      path: { userId }
    })));
  }

  withdrawRequest(changeRequestID: string, comment: string) {
    return from(ChangeRequests.withdrawChangeRequest(this.sdkOptions({
      responseStyle: 'data',
      path: { changeRequestId: changeRequestID },
      body: { comment }
    }))).pipe(map(res => (res as any)?.data ?? res));
  }

  techCheckRetestRequest(changeRequestID: string) {
    return from(ChangeRequests.requestTechCheck(this.sdkOptions({
      responseStyle: 'data',
      path: { changeRequestId: changeRequestID }
    }))).pipe(map(res => (res as any)?.data ?? res));
  }

  contactConfirmationResponse(changeRequestID: string, response: 'APPROVE' | 'REJECT', comment: string, userId: string) {
    if (response === 'APPROVE') {
      return from(ChangeRequests.approveChangeRequest(this.sdkOptions({
        responseStyle: 'data',
        path: { changeRequestId: changeRequestID },
        body: <UserComment>{ userId }
      }))).pipe(map(res => (res as any)?.data ?? res));
    } else {
      return from(ChangeRequests.rejectChangeRequest(this.sdkOptions({
        responseStyle: 'data',
        path: { changeRequestId: changeRequestID },
        body: <UserComment>{ userId, comment }
      }))).pipe(map(res => (res as any)?.data ?? res));
    }
  }

  acTCcontactConfirmationResponse(changeRequestID: string, response: boolean, comment: string, email: string) {
    return from(ChangeRequests.contactConfirmation(this.sdkOptions({
      body: {
        changeRequestId: changeRequestID,
        userEmail: email,
        confirm: response,
        comment: comment
      }
    })));
  }

  addComment(changeRequestId: string, comment: string) {
    return from(ChangeRequests.commentOnChangeRequest(this.sdkOptions({
      path: { changeRequestId },
      body: { comment }
    })));
  }

}
